import { useMutation, useQueryClient } from '@tanstack/react-query';

import { UserT } from 'business/definitions';
import { RQAPICallWithData } from 'store/APIClient';
import { useDispatch } from 'store/hooks';

/**
 * RQ Hook to delete a user
 * @param {number} userId - The id of the user to delete
 */
export const useDeleteUser = (userId: number) => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async () => {
            const response = await RQAPICallWithData({
                endpoint: `auth/user/${userId}`,
                method: 'DELETE',
            });
            return response.content;
        },

        onSuccess: ({ message }) => {
            dispatch.vision.notifyUser({
                message,
                snackType: 'info',
            });
            queryClient.setQueryData(['users'], (oldUsers: UserT[]) =>
                oldUsers.filter((user) => user.id !== userId),
            );
        },
        meta: { useGlobalOnError: true },
    });
};
